import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UiInputDirective } from '../../ui/input/input.directive';
import { UiRadioGroupComponent } from '../../ui/radio-group/radio-group.component';
import type { UiRadioGroupOption } from '../../ui/radio-group/radio-group-option';
import {
  SELECTABLE_BUCKET_TYPE_OPTIONS,
  BucketTypeOptionValue,
} from '../bucket-type-options';

@Component({
  selector: 'app-bucket-type-selector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bucket-type-selector.component.html',
  styleUrl: './bucket-type-selector.component.scss',
  imports: [FormsModule, UiInputDirective, UiRadioGroupComponent],
})
export class BucketTypeSelectorComponent {
  private static nextId = 0;

  readonly type = input.required<BucketTypeOptionValue>();
  readonly typeChange = output<BucketTypeOptionValue>();
  readonly name = input('bucketType');
  readonly disabled = input(false);
  readonly compact = input(false);
  readonly legend = input('Budget type');
  readonly inputIdPrefix = `bucket-type-selector-${BucketTypeSelectorComponent.nextId++}`;
  readonly options = SELECTABLE_BUCKET_TYPE_OPTIONS;
  readonly radioOptions: UiRadioGroupOption<BucketTypeOptionValue>[] = SELECTABLE_BUCKET_TYPE_OPTIONS.map(option => ({
    label: option.label,
    value: option.value,
    description: option.description,
  }));

  onRadioChange(nextType: BucketTypeOptionValue | null | undefined): void {
    if (nextType == null) return;
    this.onTypeChange(nextType);
  }

  onTypeChange(nextType: BucketTypeOptionValue): void {
    if (this.disabled() || nextType === this.type()) return;
    this.typeChange.emit(nextType);
  }
}
